module.exports = __webpack_public_path__ + "static/media/weather.b2420476.svg";